import { useMemo } from 'react';
import { ValueSetWrapper } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/ValueSet';
import { useValueSets } from 'src/careflow/ph-core/fhir-client/fhir-react';

const useValueSetsByIdentifiers = (identifiers: string[], options?: { autofetch?: boolean; enabled?: boolean }) => {
  // Determine if query should be enabled
  const isEnabled = options?.enabled !== false && options?.autofetch !== false;
  
  const [valueSets, callState] = useValueSets({
    filter: {
      identifier: identifiers.join(','),
    },
    map: ValueSetWrapper,
    autofetch: isEnabled, // Control when query runs
    baseQueryOptions: {
      enabled: isEnabled, // Control when query is enabled
      refetchOnWindowFocus: false, // Prevent refetch when window regains focus
      refetchOnMount: false, // Prevent refetch on mount if data exists
      refetchOnReconnect: false, // Prevent refetch on reconnect
      staleTime: 10 * 60 * 1000, // Consider data fresh for 10 minutes
    },
  });
  const valueSetsByIdentifier = useMemo(
    () =>
      identifiers.map(
        (identifierValue) =>
          valueSets.find(
            ({ identifier }) => !!identifier?.find?.(({ value }) => value === identifierValue)
          ) ?? null
      ),
    [valueSets]
  );
  return { valueSets: valueSetsByIdentifier, ...callState };
};

export default useValueSetsByIdentifiers;
